// Support the application's title/description options without a head dependency.
function createPageHeadMixin(documentRef) {
  const entries = new WeakMap();
  return {
    created() {
      const head = this.$options.head;
      if (!head) return;
      const entry = { nodes: [], disposed: false };
      entries.set(this, entry);
      entry.stop = this.$watch(
        () => typeof head === 'function' ? head.call(this) : head,
        value => {
          if (entry.disposed) return;
          entry.nodes.forEach(node => node.remove());
          entry.nodes = [];
          if (typeof value?.title === 'string') documentRef.title = value.title;
          for (const meta of value?.meta || []) {
            if (typeof meta.name !== 'string' || typeof meta.content !== 'string') continue;
            const node = documentRef.createElement('meta');
            node.setAttribute('name', meta.name);
            node.setAttribute('content', meta.content);
            documentRef.head.appendChild(node);
            entry.nodes.push(node);
          }
        },
        { immediate: true, deep: true },
      );
    },
    beforeUnmount() {
      const entry = entries.get(this);
      if (!entry) return;
      entry.disposed = true;
      entry.stop();
      entry.nodes.forEach(node => node.remove());
      entries.delete(this);
      // The router has already set the next page's title; leave it in place.
    },
  };
}

module.exports = { createPageHeadMixin };
